import { CommandPalette } from '@/components/CommandPalette';
import { TopBar } from '@/components/TopBar';
import { AppSidebar } from '@/components/sidebar/AppSidebar';
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { Toaster } from '@/components/ui/toaster';
import type { ReactNode } from 'react';

interface AppShellProps {
  children: ReactNode;
}

/**
 * Dashboard layout — the chrome that wraps every authenticated page. A
 * collapsible sidebar holds the IA and the user footer; the top bar
 * holds the sidebar trigger, a breadcrumbs slot (filled by `TopBar`'s
 * children, populated by G2-T10), the theme toggle, and the account
 * menu. `<Toaster/>` lives at the layout root so any page can fire a
 * sonner toast without remounting it.
 *
 * Mobile is handled inside the shadcn `Sidebar` primitive — at narrow
 * viewports the sidebar collapses into a `Sheet` (drawer); the trigger
 * in the top bar opens/closes either. Focus returns to the trigger on
 * close (Radix Dialog primitive behaviour).
 */
export function AppShell({ children }: AppShellProps) {
  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <TopBar />
        <main className="flex-1 px-6 py-8">{children}</main>
      </SidebarInset>
      <CommandPalette />
      <Toaster />
    </SidebarProvider>
  );
}
